<!--问题详情-->
<!--wj-->
<template>
  <div class="bbsDetail">
    <detail-title></detail-title>
    <scroll-norefresh :on-infinite="onInfinite" :on-refresh="onRefresh" @touchstart="touchStart($event)" @touchmove="touchMove($event)" @touchend="touchEnd($event)">
      <el-row class="bbs-detail">
        <p class="bbs-title">
          <strong v-html="list.tsbTitle">{{list.tsbTitle}}</strong>
        </p>
        <p class="bbs-content">{{tsbContent}}</p>
        <el-row :gutter="10">
          <viewer :images="list.tsbPic"> 
            <el-col :span="8" v-for="(m,index) in list.tsbPic" :key="index">
              <img :src="m"  style="width:100%;height: 6rem;">
            </el-col>
          </viewer>
        </el-row>
        <el-row style="padding-top:1rem;">
          <el-col :span="12" class="bbs-num">全部{{num}}个回答</el-col>
          <el-col :span="12">
              <span class="bbs-moreIcon downq" @click="downQuestion($event)">展开问题描述
                <i class="el-icon-arrow-down"></i>
              </span>
              <span class="bbs-lessIcon upq" style="display:none;" @click="upQuestion($event)">收起
                <i class="el-icon-arrow-up"></i>
              </span>
          </el-col>
        </el-row>
      </el-row>
      <div class="bbs-line"></div>
      <el-row v-for="(v,index) in answerList" :key="v.tscId" class="bbs-for">
        <img :src="v.umbi.umbiLogo" :onerror="logo" class="bbs-logo">
        <span class="bbs-detailname">{{v.umbi.umbiName}}</span>
        <p class="bbs-detailinfo" v-html="v.tscContent">{{v.tscContent}}</p>
        <el-row :gutter="10">
          <viewer :images="v.tscPic"> 
            <el-col :span="8" v-for="(t,index) in v.tscPic" :key="index">
              <img :src="t"  style="width:100%;height: 6rem;">
            </el-col>
          </viewer>
        </el-row>
        <p class="bbs-datetime">
          <span>{{v.tscDate}}</span>
        </p>
      </el-row>
    </scroll-norefresh>
    <share-wechat></share-wechat>
  </div>
</template>
<script>
import { eventBus } from "@/assets/js/eventBus";
import ShareWechat from "@/components/ShareWechat";
import Axios from "axios";
import ScrollNorefresh from "@/components/ScrollNorefresh";
import DetailTitle from '@/components/DetailTitle';
import $ from "jquery";
export default {
  data() {
    return {
      RouterAlive: true,
      logo: 'this.src="' + require("@/assets/image/tx3.svg") + '"',
      num: 0,
      answerList: [], // 回复数组
      list: [],
      answer: "",
      param: {
        curPage: 1,
        pageSize: 8,
        condition: ""
      },
      tsbId: "",
      tsbContent:'',//内容
      stsbContent:'',// 短内容
      ltsbContent:'',// 长内容
    };
  },
  components: {
    ScrollNorefresh,
    DetailTitle,
    ShareWechat
  },
  mounted() {
    const that = this;
    var locations = location.href;
    var id;
    if (locations.indexOf("?") != -1) {    //判断是否有参数
        if(locations.indexOf("from") != -1){
            var str = locations.substr(0); //从第一个字符开始 因为第0个是?号 获取所有除问号的所有符串
            var strs = str.split("?");
            id = strs[2];
            var list = id.split("=");
            that.tsbId = list[1];
        }else{
            var str = locations.substr(0); //从第一个字符开始 因为第0个是?号 获取所有除问号的所有符串
            var strs = str.split("?");
            id = strs[1];
            var list = id.split("=");
            that.tsbId = list[1];
            //用等号进行分隔 （因为知道只有一个参数 所以直接用等号进分隔 如果有多个参数 要用&号分隔 再用等号进行分隔）
        }
    }
    that.getcontents();
    that.getAnswers();
  },
  methods: {
    // 展开问题描述
    downQuestion(e) {
      const that = this;
      e.cancelBubble = true;
      $(".downq").hide();
      $(".upq").show();
        that.tsbContent = that.ltsbContent;
    },
    // 收起问题描述
    upQuestion(e) {
      const that = this;
      e.cancelBubble = true;
      $(".upq").hide();
      $(".downq").show();
      that.tsbContent = that.stsbContent;
    },
    // 上拉加载更多
    onInfinite(done) {
      const that = this;
      that.do = done;
      if (that.answerList.length >= that.num) {
        eventBus.$emit("loadingMore", false);
      } else {
        that.param = {
          curPage: ++that.param.curPage,
          pageSize: 8,
          condition: that.tsbId
        };
        Axios.post(that.$store.state.APIURLS + "Tsc/findByPage",that.param).then(res => {
            if (res.data.code == 0) {
                res.data.data.forEach(element => { 
                    element.umbi.umbiLogo = element.umbi.umbiLogo? element.umbi.umbiLogo: "";
                    that.answerList.push(element);
                });
                if (res.data.data.length < that.param.pageSize) {
                    eventBus.$emit("loadingMore", false);
                }
            }
            done();
        },
        response => {
            console.log("error");
        });
      }
    },
    // 下拉刷新
    onRefresh(done) {},
    // 获取问题的接口https
    getcontents() {
      const that = this;
      Axios.get(that.$store.state.APIURLS + "Tsb/findById?tsbId=" + that.tsbId).then(function(res) {
        if (res.data.code == 200) {
          if(res.data.data.tsbPic){
            res.data.data.tsbPic = res.data.data.tsbPic.split(',');
          }else{
            res.data.data.tsbPic =[];
          }
          that.ltsbContent = res.data.data.tsbContent;
          if(res.data.data.tsbContent.length>40){
            $(".upq").hide();
            $(".downq").show();
            that.stsbContent = res.data.data.tsbContent.substr(0,40);
            that.tsbContent = that.stsbContent;
          }else{
              $(".downq").hide();
              $(".upq").hide();
              that.tsbContent = res.data.data.tsbContent; 
          }
          that.list = res.data.data;
          that.shareList={
            title: res.data.data.tsbTitle,
            content: "",
          }
          eventBus.$emit("shareList",shareList);
        }
      });
    },
    // 获取回复的接口https
    getAnswers() {
      const that = this;
      that.param = {
        curPage: 1,
        pageSize: 8,
        condition: that.tsbId
      };
      Axios.post(that.$store.state.APIURLS + "Tsc/findByPage", that.param).then(
        function(res) {
          if (res.data.code == 200) {
            that.num = res.data.data.count;
            res.data.data.data.forEach(e => {
              e.umbi.umbiLogo = e.umbi.umbiLogo ? e.umbi.umbiLogo : "";
              e.tscPic = e.tscPic?e.tscPic.split(','):[];
              that.answerList.push(e);
            });
            if (res.data.data.data.length < that.param.pageSize) {
              eventBus.$emit("loadingMore", false);
            }
          }
        }
      );
    },
  },
};
</script>


